import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledContainer = styled.div`
  max-width: 768px;
  margin: auto;
  ${MediaQueries.mbUp} {
    padding: 32px 0 0 0;
  }
  text-align: center;
  .heading {
    padding: 0 40px;
    color: #2d87f3;
    opacity: 0;
  }

  .description {
    margin-top: 8px;
    color: ${theme.colors.gray500};
    opacity: 0;
  }
`

export const StyledChartContainer = styled.div`
  padding: 0 0 32px 0;
  margin-top: 40px;
  ${MediaQueries.mbUp} {
    min-height: 410px;
  }

  ${MediaQueries.mbDown} {
    min-height: 365px;
  }
`

export const StyledBarChart = styled.div`
  ${MediaQueries.mbUp} {
    height: 410px;
  }

  ${MediaQueries.mbDown} {
    height: 365px;
  }
`

export const StyledChartLegend = styled.div`
  color: ${theme.colors.gray500};
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;

  ${MediaQueries.mbUp} {
    display: flex;
    justify-content: space-between;
    margin-top: 33px;
    padding: 0 30px 0 90px;
    .legend {
      display: flex;
    }
  }
  ${MediaQueries.mbDown} {
    margin: 16px 0 0 70px;
    display: block;
    .legend {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }
  }
  .legend {
    .legend-label {
      text-align: start;
    }
  }
`

export const StyledLegendBox = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 6px;
  border-radius: ${theme.borderRadius};
`
